import React, {Component, Fragment} from 'react';
import { useState, useEffect } from "react";
import {PieChart, PieChartProduct, Linechart, Barchart, BarCountires} from './ChartsUserActivity';
import { API_BASE_URL } from '../config';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    SingleFieldList,
    ChipField,
    ArrayField,
    Pagination,
    Edit,
    Create,
    TextInput,
    EditButton,
    SimpleForm,
    // ReferenceInput,
} from 'react-admin';
import {AuthenticatedLink} from './AuthenticatedLink';
import {
	Grid,
	Paper,
	Button,
	CircularProgress,
    FormControlLabel,
	// FormControl,
} from '@material-ui/core';

// import {
//     MuiPickersUtilsProvider,
//     KeyboardTimePicker,
//     KeyboardDatePicker,
//   } from '@material-ui/pickers';
//import { Form } from 'redux-form';
// import DateFnsUtils from "@date-io/date-fns";

class UserActivityReportDownloader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            reportName: props.record.id
        };
    }

    render() {
        return (
            <AuthenticatedLink url={`${API_BASE_URL}/ScheduledTask/DownloadReport?reportName=${this.state.reportName}`} filename={this.state.reportName}>Download</AuthenticatedLink>
        );
    }
}

const paddingStyle = {
    padding: "2em",
}

class UAGen extends Component {
    constructor(props) {
        super(props)
        let [month, date, year] = ( new Date() ).toLocaleDateString().split("/");
        let startYear = month === "1" ? (year - 1).toString() : year;
        let startMonth = month === "1" ? "12" : (month - 1).toString();
        this.state = {
            start: `${startYear}-${startMonth.padStart(2, '0')}-${date.padStart(2, '0')}`,
            end: `${year}-${month.padStart(2, '0')}-${date.padStart(2, '0')}`,
            fetching: false,
            url: props.url,
        };
    }

    onGenerateClick = async () => {
        this.setState({ fetching: true });
        const token = localStorage.getItem('token');
        const result = await fetch(`${this.state.url}?start=${this.state.start}&end=${this.state.end}`, {	
            headers: new Headers({ Authorization: `Bearer ${token}` })
        }).then((res) => res.json());

        if (result) {
            this.setState({ fetching: false });
            localStorage.removeItem('dt');
            var dt = `${this.state.url}?start=${this.state.start}&end=${this.state.end}`;
            localStorage.setItem('dt', JSON.stringify(dt));
            window.location.reload();
        }
    }

    render() {
        return (
            <Paper style={paddingStyle}>
                <Grid
                container
                spacing={1}
                direction="row"
                justify="flex-start"
                alignItems="flex-end"
                >
                    {/* <Grid item xs={2}> */}
                        <FormControlLabel 
                        label="Start Date (yyyy-mm-dd)" 
                        labelPlacement="top"
                        control={<input type="text" value={this.state.start} onChange={(e) => this.setState({ start: e.target.value })}></input>}/>
                    {/* </Grid>
                    <Grid item xs={2}> */}
                        <FormControlLabel 
                        label="End Date" 
                        labelPlacement="top"
                        control={<input type="text" value={this.state.end} onChange={(e) => this.setState({ end: e.target.value })}></input>}/>
                    {/* </Grid>
                    <Grid item xs={1}> */}
                        <Button
                        enabled={this.state.fetching ? 'false' : 'true' }
                        color={this.state.fetching ? "default" : "primary" } 
                        variant="contained" 
                        size='small'
                        onClick={() => this.onGenerateClick()} >{this.state.fetching ? <CircularProgress /> : <span>Generate</span>}</Button>
                    {/* </Grid>
                    <Grid item xs={7}> */}
                        <span>
                            {this.state.fetching ? "Your report is being generated. This might take several minutes. The page will refresh when the report is ready" : null}
                        </span>
                    {/* </Grid> */}
               </Grid>
            </Paper>
        );
    }
}

function DrawCharts() {
    var dataPie = [];
    var dataPieProduct = [];
    var dataBar = [];
    var dataCountry = [];
    var createCharts = true;

    const [items, setItems] = useState([]);
    
    useEffect(() => {
        async function fetchrData() {
            const dtr = JSON.parse(localStorage.getItem('dt'));
            if (dtr){
                const resultr = await fetch(dtr, {	
            headers: new Headers({ Authorization: `Bearer ${localStorage.getItem('token')}` })
         }).then((res) => res.json());
         setItems({...resultr});
        }
    }
    fetchrData();
    }, []);

    const [calcount, setCalcount] = useState({});
    useEffect(() => {
        async function fetchData() {
        const calcount = await fetch(`${API_BASE_URL}/ScheduledTask/GenerateCalculationCount`, {	
            headers: new Headers({ Authorization: `Bearer ${localStorage.getItem('token')}` })
         }).then((res) => res.json());
        setCalcount(calcount);
    }
    fetchData();
    }, []);

    if(items && Object.keys(items).length !== 0){localStorage.removeItem('dt');}
    if(items.length === 0 || Object.keys(items).length === 0){createCharts = false;}
    if(Object.keys(items).length > 0)
    {
        var ExternalCalc = Object.values(items).filter((activity) => activity.isExternal === true).length;
        var InternalCalc = Object.values(items).filter((activity) => activity.isExternal === false).length;
        var GHEXProd = Object.values(items).filter((activity) => activity.productType === "GHEX").length;
        var BHEXProd = Object.values(items).filter((activity) => activity.productType === "BHEX").length;
        var SWProd = Object.values(items).filter((activity) => activity.productType === "SW").length;
        var SegTotal = Object.values(items).filter((activity) => activity.segment).length;
        var SegHVAC = (Object.values(items).filter((activity) => activity.segment === "HVAC").length)*100/SegTotal;
        var SegIndustry = (Object.values(items).filter((activity) => activity.segment === "Industry").length)*100/SegTotal;
        var SegMarine = (Object.values(items).filter((activity) => activity.segment === "Marine").length)*100/SegTotal;
        var SegIRF = (Object.values(items).filter((activity) => activity.segment === "Ind. Refrigeration").length)*100/SegTotal;
        var SegHVACandR = (Object.values(items).filter((activity) => activity.segment === "HVAC&R").length)*100/SegTotal;
        var ResCountries = Object.values(items).map((activity) => activity.country)
        var counts = ResCountries.reduce((map, val) => {map[val] = (map[val] || 0)+1; return map}, {} );
        var ArrayCounts = Object.entries(counts);
        var SortedCount = ArrayCounts.sort(function(a, b) { return a[1] < b[1] ? 1 : -1;});
        var TopCountries = SortedCount.slice(0, 10);
        var PerMonthCount = Object.entries(calcount);
        
        dataPie = [
            ['User', 'Calculations'],
            ['External',  ExternalCalc],
            ['Internal', InternalCalc],
        ];
        dataPieProduct = [
            ['ProductType', ''],
            ['GHEX',  GHEXProd],
            ['SW', SWProd],
            ['BHEX', BHEXProd],
        ];
        dataBar = [
            ["Segments", ""],
            ["HVAC", SegHVAC,],
            ["Ind", SegIndustry],
            ["Mrn", SegMarine],
            ["IRF", SegIRF],
            ["HVACR", SegHVACandR],
        ];
        dataCountry = [
            ['Countries', ''],
            ...TopCountries
        ];
        var dataLine = [
            ["Month", ""],
            ...PerMonthCount.reverse()
        ];
    }

    if(Object.keys(items).length !== 0)
        {
            localStorage.removeItem('items');
        }

    if(createCharts){
        return (
        <>
        <Paper style={paddingStyle}>
            <Grid >
                <Grid container >
                    <Grid item xs={2}>
                    <PieChart data={dataPie}/>
                    </Grid>
                    <Grid item xs={2}>
                    <Linechart data2={dataLine}/>
                    </Grid>
                    <Grid item xs={2}>
                    <PieChartProduct dataprod={dataPieProduct}/>
                    </Grid>
                    <Grid item xs={2}>
                    <Barchart data3={dataBar}/>
                    </Grid>
                    <Grid item xs={4}>
                    <BarCountires datacountries={dataCountry}/>
                    </Grid>
                </Grid>
            </Grid>
            </Paper>
        </>
        );
    }
    else{
        return<></>
    }}

export const UserActivityList = (props) => (
    <Fragment>
        <DrawCharts/>
        <h3>Generate Report</h3>
        <UAGen url={`${API_BASE_URL}/ScheduledTask/GenerateActivityReport`} />
        <h3>Previous Reports</h3>
        <List {...props} exporter={false} bulkactions="false" title="HEXSelector User Activity">
            <Datagrid>
                <UserActivityReportDownloader label="Get Report" source="id"  sortable={false}/>
                <TextField label="Filename" source="filename" sortable={false} />
                <DateField label="Report Start Date" source="rangeStart" sortable={true} />
                <DateField label="Report End Date"  source="rangeEnd"  sortable={true}/>
                <DateField label="Generated On"  source="generatedOn"  sortable={true}/>
            </Datagrid>
        </List>
    </Fragment>
);

export const VIPCustomerList = (props) => (
    <Fragment>
        <List {...props} exporter={false} bulkactions="false" title="HEXSelector VIP Customers" pagination={<Pagination rowsPerPageOptions={[10,25,100,500]} />}>
            <Datagrid>
                <TextField label="Name" source="name"></TextField>
                <TextField label="Country" source="country"></TextField>
                <TextField label="Segment" source="segment"></TextField>
                <ArrayField label="Aliases" source="aliases"> 
                    <SingleFieldList>
                        <ChipField ></ChipField>
                    </SingleFieldList>
                </ArrayField>
                <EditButton></EditButton>
            </Datagrid>
        </List>
    </Fragment>
);

export const VIPCustomerEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="name" label="Name"></TextInput>
            <TextInput source="country" label="Country"></TextInput>
            <TextInput source="segment" label="Segment"></TextInput>
        </SimpleForm>
    </Edit>
)

export const VIPCustomerCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" label="Name"></TextInput>
            <TextInput source="country" label="Country"></TextInput>
            <TextInput source="segment" label="Segment"></TextInput>
        </SimpleForm>
    </Create>
)